module.exports = __webpack_public_path__ + "static/img/bottom.7bc65209.png";